import {Component, OnInit, ViewChild} from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core-v2';
import {ExgDataTableComponent, ExgModalService} from 'exc-controls-v2';
import {ExgFilterComponent} from '../misc/exg-filter/exg-filter.component';
import {ExcRestMode, ExcRestService, IExcDataFilter, IExcDataPaging, IExcDataSort} from 'exc-rest-v2';
import {IExcMetaInfo} from 'exc-rest-v2/lib/interfaces/IExcMetaInfo';
import {IExgTab} from 'exc-tab-v2';
import {BehaviorSubject} from 'rxjs';
import {ApplicationService} from '../services/application.service';
import {EnumerationService} from '../services/enumeration.service';

@Component({
  selector: 'app-leistungserfassung-list',
  templateUrl: './leistungserfassung-list.component.html',
  styles: []
})
export class LeistungserfassungListComponent extends ExcTranslation implements OnInit, IExgTab {
  /****************************/
  @ViewChild('VCserviceRecordTable', {read: ExgDataTableComponent}) VCserviceRecordTable!: ExgDataTableComponent;
  @ViewChild('VCserviceRecordTableFilterControl', {read: ExgFilterComponent}) VCserviceRecordTableFilterControl!: ExgFilterComponent;
  @ViewChild('VCserviceRecordTableSortControl', {read: ExgFilterComponent}) VCserviceRecordTableSortControl!: ExgFilterComponent;
  @ViewChild('VCserviceRecordTableSearchControl', {read: ExgFilterComponent}) VCserviceRecordTableSearchControl!: ExgFilterComponent;
  /****************************/
  init = true;
  tabinstance: any;
  Data: any;
  preFilterDefinition: any[] = [];
  selectedMod: any;

  serviceRecordTable = {
    selectKey: 'leID',
    state: 1,
    searchValue: '',
    selectedRow: undefined as any,
    data: [] as any[],
    isLoading: true,
    uiFilterEnumGroup: [] as any[],
    uiFilterSearchFields: [
      {table: 'Leistungsaufstellung', tableField: 'leNr', tableFieldCaptionAlt: 'Nummer'},
      {table: 'Leistungsaufstellung', tableField: 'leName', tableFieldCaptionAlt: 'Bezeichnung'},
      {table: 'Leistungsaufstellung', tableField: 'leCRU', tableFieldCaptionAlt: 'Ersteller'},
      {table: 'Leistungsaufstellung', tableField: 'leCRD', tableFieldCaptionAlt: 'Erstelldatum'},
    ],
    uiSortFieldGroup: [
      {fieldGroup: 'Leistungsaufstellung', fieldTable: 'All', fieldName: 'leCRD', uiName: 'Erstelldatum'},
      {fieldGroup: 'Leistungsaufstellung', fieldTable: 'All', fieldName: 'leNr', uiName: 'Nummer'},
      {fieldGroup: 'Leistungsaufstellung', fieldTable: 'All', fieldName: 'leName', uiName: 'Bezeichnung'},
    ],
    uiFilter: [] as any[],
    uiSort: [] as any[],
    MetaInfo: {
      dataPaging: {pageNo: 0, pageSize: 25} as IExcDataPaging,
      dataSort: {} as IExcDataSort,
      dataFilter: {} as IExcDataFilter
    } as IExcMetaInfo,
    paging: {pagingPage: 0, pagingEndRow: 0, pagingPageSize: 25, pagingTotalPages: 0, pagingTotalRows: 0, pagingStartRow: 0},
    ready: () => {
      if (this.serviceRecordTable.data.length === 0) {
        this.serviceRecordTable.state = 2;
      } else {
        this.serviceRecordTable.state = 0;
        if (this.VCserviceRecordTable) {
          this.VCserviceRecordTable.selectedRow = 0;
        }
      }
      this.init = false;
      this.serviceRecordTable.isLoading = false;
      this.tableIsLoading.next(this.serviceRecordTable.isLoading);
    },
    selectionChanged: (index: number) => {
      this.serviceRecordTable.selectedRow = this.serviceRecordTable.data[index];
      this.tableIsLoading.next(false);
    },
    dblClick: (index: number) => {
      this.serviceRecordTable.selectionChanged(index);
      this.VCserviceRecordTable.selectedRow = index;
      this.openCheckview();
    },
    pageChanged: (page: number) => {
      if (this.serviceRecordTable.MetaInfo.dataPaging !== undefined) {
        this.serviceRecordTable.MetaInfo.dataPaging.pageNo = page;
      }
      this.serviceRecordTable.loadData();
    },
    search: (value: string) => {
      this.serviceRecordTable.searchValue = value;
      this.serviceRecordTable.pageChanged(0);
    },
    loadData: () => {
      const SELF = this;
      SELF.serviceRecordTable.state = 1;
      SELF.serviceRecordTable.isLoading = true;
      SELF.tableIsLoading.next(SELF.serviceRecordTable.isLoading);
      SELF.excRestService
        .sget(SELF.excRestService.computeUrl(SELF.selectedMod.endpoint, {
          fts: SELF.serviceRecordTable?.searchValue
        }), ExcCoreModule.Guid.NewGuid(), {MetaInfo: SELF.serviceRecordTable.MetaInfo}, ExcRestMode.BASIC)
        .subscribe(
          (data: any) => {
            SELF.serviceRecordTable.setData(data.data, data.paging);
          }
        ).add(() => {
          SELF.serviceRecordTable.ready();
        });
    },
    setData: (incomingData: any, incomingPaging: any) => {
      this.serviceRecordTable.data = incomingData || [];
      this.serviceRecordTable.paging = incomingPaging || this.serviceRecordTable.paging;
    }
  };
  tableIsLoading = new BehaviorSubject(this.serviceRecordTable.isLoading);

  constructor(
    public appSvc: ApplicationService,
    public enumSvc: EnumerationService,
    private excRestService: ExcRestService,
    private modal: ExgModalService
  ) {
    super();
  }

  ngOnInit(): void {
    const SELF = this;
    SELF.preFilterDefinition = [
      {
        value: 'active',
        endpoint: 'LeistungserfassungList',
        get caption(): string {
          return SELF.getRessource(this.value + '.caption');
        }
      },
      {
        value: 'approved',
        endpoint: 'LeistungserfassungListApproved',
        get caption(): string {
          return SELF.getRessource(this.value + '.caption');
        }
      },
      {
        value: 'canceled',
        endpoint: 'LeistungserfassungListCanceled',
        get caption(): string {
          return SELF.getRessource(this.value + '.caption');
        }
      }
    ];
    SELF.selectedMod = SELF.preFilterDefinition[0];
    if (this.tabinstance) {
      this.tabinstance.Label = this.getRessource('Label');
    }
    this.serviceRecordTable.uiFilter = this.appSvc.metaInfo.dataFilter(
      this.serviceRecordTable.uiFilterEnumGroup, this.serviceRecordTable.uiFilterSearchFields);
    this.serviceRecordTable.uiSort = this.appSvc.metaInfo.dataSort(this.serviceRecordTable.uiSortFieldGroup);
    this.serviceRecordTable.loadData();
  }

  openCheckview(): void {
    if (this.serviceRecordTable.selectedRow) {
      this.appSvc.Leistungserfassung.Checkview.OpenTab(this.serviceRecordTable.selectedRow);
    }
  }

  changePreFilterMod(event: any): void {
    this.selectedMod = event;
    this.serviceRecordTable.selectedRow = undefined;
    this.serviceRecordTable.pageChanged(0);
  }

  restore(): void {
    const serviceRecord = this.serviceRecordTable.selectedRow;
    if (!serviceRecord) {
      return;
    }
    this.modal.showSimple(
      this.getRessource('restoreServiceRecordHeader'),
      this.getRessource('restoreServiceRecordMessage'),
      true,
      true,
      this.getGlobal('Confirm'),
      this.getGlobal('Cancel')
    ).subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.excRestService.put(
          this.excRestService.computeUrl('LeistungserfassungUpdateRestore', {}),
          {leID: serviceRecord.leID,
           UPT: serviceRecord.leUPT
          },
          {}
        ).subscribe((response: any) => {
          if (response?.success) {
            this.modal.showToast(
              this.getRessource('restoreServiceRecordSuccess', {entry: serviceRecord.leName}),
              'md-toast bg-green',
              'far fa-check'
            );
          } else {
            this.modal.showToast(
              this.getRessource('restoreServiceRecordFailed',
              {entry: serviceRecord.leName}),
              'md-toast',
              'fas fa-exclamation'
            );
          }
          this.serviceRecordTable.loadData();
        });
      }
    });
  }

  cancelServiceRecord(): void {
    const serviceRecord = this.serviceRecordTable.selectedRow;
    if (!serviceRecord) {
      return;
    }
    this.modal.showSimple(
      this.getRessource('cancelServiceRecordHeader'),
      this.getRessource('cancelServiceRecordMessage'),
      true,
      true,
      this.getGlobal('Confirm'),
      this.getGlobal('Cancel')
    ).subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.excRestService.put(
          this.excRestService.computeUrl('LeistungserfassungUpdateCancel', {}),
          {leID: serviceRecord.leID, UPT: serviceRecord.leUPT},
          {}
        ).subscribe((response: any) => {
          if (response?.success) {
            this.modal.showToast(
              this.getRessource('cancelServiceRecordSuccess', {entry: serviceRecord.leName}),
              'md-toast bg-green',
              'far fa-check'
            );
          } else {
            this.modal.showToast(
              this.getRessource('cancelServiceRecordFailed', {entry: serviceRecord.leName}),
              'md-toast',
              'fas fa-exclamation'
            );
          }
          this.serviceRecordTable.loadData();
        });
      }
    });
  }



  sumTotal(serviceRecord: any): number {
    return (serviceRecord.leHonorarleistungSum || 0)
      + (serviceRecord.leFahrtkostenSum || 0)
      + (serviceRecord.leSonstigeKostenSum || 0)
      + (serviceRecord.leAuslagenSum || 0);
  }

}
